/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Html from 'Component/Html';
import Image from 'Component/Image';
import Link from 'Component/Link';
import media, {WYSIWYG_MEDIA} from 'Util/Media/Media';

import { getPostUrl } from '../../../../util/Posts';

import './EventsBlogPostCard.style';

/** @namespace ScandiPWA/Blog/Component/BlogPostCard/EventsBlogPostCard/Component */
export class EventsBlogPostCard extends PureComponent {
    static propTypes = {
        post: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.bool
        ]),
        isPlaceholder: PropTypes.bool,
        isCompactOnMobile: PropTypes.bool
    };

    static defaultProps = {
        post: false,
        isPlaceholder: false,
        isCompactOnMobile: false
    };

    renderImage() {
        const {
            post: {
                first_image,
                media_gallery,
                title
            },
            topFirstEvents,
            post
        } = this.props;

        if(topFirstEvents && media_gallery) {
            const mediaGalleryArray = media_gallery.split(';');

            if(mediaGalleryArray[0]){
                return (
                    <div
                        mix={ { block: 'EventsBlogPostCard', elem: 'ImageWrapper' } }
                    >
                        <Image
                            mix={ { block: 'EventsBlogPostCard', elem: 'Image' } }
                            ratio="square"
                            src={ media(mediaGalleryArray[0]) }
                        />
                    </div>
                );
            }
        }

        if (!first_image) {
            return null;
        }

        return (
            <Link
                to={ getPostUrl(post) }
                title={ __('View %s', title) }
                mix={ { block: 'EventsBlogPostCard', elem: 'ImageWrapper' } }
            >
                <Image
                    mix={ { block: 'EventsBlogPostCard', elem: 'Image' } }
                    ratio="square"
                    src={ first_image }
                />
            </Link>
        );
    }

    getFormattedDate(created_at) {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        if(!created_at)
            return created_at;

        const fixedDate = created_at.replace(/-/g, '/');
        const date = new Date(fixedDate);

        return date ? __("%s %s '%s", date.getDate(), monthNames[date.getMonth()], date.getFullYear().toString().substr(-2)) : created_at;
    }

    renderPublishDate() {
        const { post: { publish_time }, post } = this.props;
        if (!publish_time) {
            return null;
        }

        return (
            <div block="EventsBlogPostCard" elem="Date">
                { this.getFormattedDate(publish_time) }
            </div>
        );
    }

    renderTitle() {
        const { post: { title }, post } = this.props;
        if (!title) {
            return null;
        }

        return (
            <div block="EventsBlogPostCard" elem="Title">
                <Link to={ getPostUrl(post) }>
                    { title }
                </Link>
            </div>
        );
    }

    renderDescription() {
        const { post: { short_content } } = this.props;

        if (!short_content) {
            return null;
        }

        return <Html content={ short_content } />;
    }

    renderContents() {
        const { isPlaceholder, serialNumber, latestEvents, topFirstEvents, post, totalPosts } = this.props;

        if (isPlaceholder) {
            return null;
        }

        if(topFirstEvents) {
            return (
                <>
                    <div block="EventsBlogPostCard" elem="ContentWrapper" mods={ { expand: true } }>
                        { this.renderImage() }
                        <div block="EventsBlogPostCard" elem="Details">
                            { this.renderTitle() }
                            <div block="EventsBlogPostCard" elem="DescriptionWrapper">
                                { this.renderDescription() }
                            </div>
                            <Link to={ getPostUrl(post) } className={'Events_LatestPost_link Button'}>{ __('READ & SHOP') }</Link>
                        </div>
                    </div>
                </>
            );
        }

        return (
            <div block="EventsBlogPostCard" elem="ContentWrapper" mods={ { expand: true } }>
                { this.renderImage() }
                <div block="EventsBlogPostCard" elem="Details">
                    <div block="EventsBlogPostCard" elem="DetailsContent">
                        { this.renderTitle() }
                        <div block="EventsBlogPostCard" elem="DescriptionWrapper">
                            { this.renderDescription() }
                        </div>
                        { this.renderPublishDate() }
                    </div>
                </div>
            </div>
        );
    }


    render() {
        const { isPlaceholder, isCompactOnMobile, serialNumber, topFirstEvents } = this.props;

        if(!topFirstEvents && serialNumber === 0)
            return null;

        return (
            <div block="EventsBlogPostCard" mods={ { isLoading: isPlaceholder, isCompactOnMobile } }>
                { this.renderContents() }
            </div>
        );
    }
}

export default EventsBlogPostCard;
